import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useApi, errMsg } from "@/lib/api";
import { KeyFormDialog } from "@/components/apikeys/KeyFormDialog";
import { SecretDialog } from "@/components/apikeys/SecretDialog";
import { KeyRow } from "@/components/apikeys/KeyRow";

export const PartnerKeys = ({ data, reload }) => {
  const api = useApi();
  const [form, setForm] = useState(null);
  const [secret, setSecret] = useState("");
  const act = async (path, msg) => {
    try { const r = await api("post", path); if (r.secret) setSecret(r.secret); toast.success(msg); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const saved = (res) => { setForm(null); if (res.secret) setSecret(res.secret); reload(); };
  return (
    <div className="space-y-4" data-testid="partner-keys">
      <div className="flex items-center">
        <p className="text-sm text-stone-600">{data ? `${data.keys.length} clé(s)` : "Chargement…"}</p>
        <Button className="ml-auto bg-[#C2410C] hover:bg-[#9A3412] text-white" onClick={() => setForm({})} data-testid="create-key-button"><Plus className="h-4 w-4 mr-1.5" /> Nouvelle clé</Button>
      </div>
      <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            {["Partenaire", "Clé", "Accès", "Contrôles", "Utilisation", "État", ""].map((h, i) => <TableHead key={i} className="text-xs uppercase tracking-[0.1em] text-stone-500">{h}</TableHead>)}
          </TableRow></TableHeader>
          <TableBody>
            {data?.keys.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-10 text-stone-500" data-testid="keys-empty">Aucune clé pour l'instant. Créez-en une pour un partenaire.</TableCell></TableRow>}
            {data?.keys.map((k) => <KeyRow key={k.id} k={k} onEdit={() => setForm({ edit: k })}
              onRegenerate={() => act(`/api-keys/${k.id}/regenerate`, "Nouvelle clé générée, l'ancienne ne fonctionne plus")}
              onRevoke={() => act(`/api-keys/${k.id}/revoke`, "Clé révoquée")}
              onToggle={async () => { try { await api("patch", `/api-keys/${k.id}`, { is_active: k.status !== "active" }); reload(); } catch (e) { toast.error(errMsg(e)); } }} />)}
          </TableBody>
        </Table>
      </div>
      <KeyFormDialog open={!!form} edit={form?.edit} modules={data?.modules} onClose={() => setForm(null)} onSaved={saved} />
      <SecretDialog secret={secret} onClose={() => setSecret("")} />
    </div>
  );
};
